var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "super_nav_inner" },
    [
      _c(
        "div",
        { staticClass: "tabs" },
        [
          _c(
            "el-tabs",
            {
              on: { "tab-click": _vm.tabChange },
              model: {
                value: _vm.activeTab,
                callback: function ($$v) {
                  _vm.activeTab = $$v
                },
                expression: "activeTab",
              },
            },
            _vm._l(_vm.value.config.value, function (item, index) {
              return _c(
                "el-tab-pane",
                { key: index, attrs: { name: index + "" } },
                [
                  _c("template", { slot: "label" }, [
                    _c(
                      "div",
                      {
                        style: {
                          color:
                            _vm.activeTab == index
                              ? _vm.value.config.selected_color
                              : item.name_color,
                        },
                      },
                      [_vm._v(" " + _vm._s(item.name) + " ")]
                    ),
                    _vm.value.config.is_open_sub_name === "1" && item.sub_name
                      ? _c(
                          "div",
                          {
                            staticClass: "sub_name",
                            style: {
                              color:
                                _vm.activeTab == index
                                  ? "#fff"
                                  : item.sub_name_color,
                              background:
                                _vm.activeTab == index
                                  ? _vm.value.config.selected_color
                                  : "transparent",
                            },
                          },
                          [_vm._v(" " + _vm._s(item.sub_name) + " ")]
                        )
                      : _vm._e(),
                  ]),
                ],
                2
              )
            }),
            1
          ),
        ],
        1
      ),
      _c(_vm.currentData.key, {
        tag: "component",
        attrs: { defaultValue: _vm.defaultValue, parentKey: "super_nav" },
        model: {
          value: _vm.currentData,
          callback: function ($$v) {
            _vm.currentData = $$v
          },
          expression: "currentData",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }